
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "deleteNote",
      resolverType: "mutation",
      routePath: "/deleteNote",
      httpMethod: "POST",
    });
  